<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name">Sales Import</div>
        </div>
        <!--page content-->
        <div class="admin-page-content">
            <form id="importTasksform" enctype="multipart/form-data">
            <div class="form-row">
                <div class="col-md-6 form-group">
                    <label> Select Excel File to Import Sales Data:</label>
                    <div>
                        <input style="display: none;" type="file" name="excl_file" accept=".xlsx,.xls" id="glexportupload" ref="fileglexportdata" v-on:change="handleFilesUploadCall()"/>
                        <label class="btn btn-secondary mb-0" for="glexportupload"><i class="fa fa-upload mr-3" aria-hidden="true"></i>Upload File ...</label>
                        <button type="button" v-on:click="importData" class="btn btn-primary">Import</button>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <br>
        <div>
            <template>
                <!-- <div class="custom-table-name">Record not found</div> -->
            </template>
        </div>
        <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
import Vue from "vue";
import Footer from "@/components/partials/Footer";
import {commonMixins} from '../../mixins/commonMixins';
import EventBus from ".././event-bus";
import {importsales} from '../../config'
import axios from 'axios'

Vue.component("app-footer", Footer);

var app = '';

export default {
    name: 'Login',
    mixins: [commonMixins],
    data() {
        return {
                import_data:[],
                import_data_temp:[],
                filesUserData: [],
        }
    },
    created: function () {
    },
    beforeMount: function () {
        app = this;
        app.checkLocalStorage();
    },
    mounted: function () {
        app.setActiveMenu('sales');
        EventBus.$emit("menu-selection-changed", "sales");
    },
    methods: {
        checkLocalStorage : function () {
            var token = app.$route.query.token;
            token = (token === null || typeof (token) === "undefined" || token == '') ? '' : token;
            app.redirectUrl = app.$route.query.redirect_url;
            app.redirectUrl = (app.redirectUrl === null || typeof (app.redirectUrl) === "undefined" || app.redirectUrl == '') ? '' : app.redirectUrl;
            if (token != "") {
                app.getUserFromToken(token, "login");
            } else {
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    var apiToken = localStorage.getItem("api_token");
                    apiToken = (apiToken === null || typeof (apiToken) === "undefined" || apiToken == '') ? '' : apiToken;
                    if (apiToken != '') {
                        if (app.redirectUrl != '') {
                            openDirectLink(app.redirectUrl);
                        }
                        if(token != '') {
                            app.$router.push('/sales');
                        }
                    }else {
                        localStorage.clear();
                        let $url=process.env.SSO_URL + "/login?redirect=" + process.env.APP_URL + "&slug=" + process.env.APP_SLUG;
                        openDirectLink($url);
                    }
                } else {
                    localStorage.clear();
                    let $url=process.env.SSO_URL + "/login?redirect=" + process.env.APP_URL + "&slug=" + process.env.APP_SLUG;
                    openDirectLink($url);
                }
            }
        },
        isNumeric: function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        importData() {
                if(app.filesUserData) {
                    if(app.filesUserData.length>0) {
                        $(".loading-container").show();
                    var formData = new FormData();
                    let file = app.filesUserData[0];
                    formData.append('sales', file);
                    // formData.append('api_token', window.localStorage.getItem('api_token'));
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    };
                    axios.post(importsales, formData, config)
                            .then(function (response) {
                            app.$refs.fileglexportdata.value = '';
                            if(response.data.code=='204') {
                                setTimeout(function() { $(".loading-container").hide(); },1000);
                                alert(response.data.message);
                            } else if (response.data.code == '200') {
                                alert(response.data.message);
                            } else {
                                // console.log("fail");
                                app.import_data=[];
                            }
                            setTimeout(function() { $(".loading-container").hide(); },2000);
                            // $(".loading-container").hide();
                    })
                    .catch(function (err) {
                        app.$refs.fileglexportdata.value = '';
                        app.import_data=[];
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("api_token");
                            self.$router.push("/");
                            //EventBus.$emit("logged-in", true, "", "");
                        }
                        // $(".loading-container").hide();
                        setTimeout(function() { $(".loading-container").hide(); },2000);
                    });
                    } else {
                        alert("Please select file to import.");
                    }
                } else {
                        alert("Please select file to import.");
                    }
                //$(".loading-container").hide();
        },
        handleFilesUploadCall: function () {
            if(app.$refs.fileglexportdata.files.length>0)
            {
                app.filesUserData = app.$refs.fileglexportdata.files;
                let allowedextentions = /(\.xls|\.xlsx)$/i;
                if (!allowedextentions.exec(app.filesUserData[0].name)) {
                alert("Please select valid file!");
                //app.filesUserData="";
                app.$refs.fileglexportdata.value = '';
                }
            }
        },
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sales/sales.vue